import axios from "axios";
import tokenService from "./token";

const jobApi = axios.create({
  baseURL: process.env.REACT_APP_JOB_URL,
});

jobApi.interceptors.request.use(
  config => {
    config.headers['Authorization'] = `bearer ${tokenService.getToken() || ''}`;
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

export default jobApi;